import { Modal, ModalContent, type ModalProps } from "@heroui/react";
import { useLocation } from "react-router";

import SignIn from "./index";

export function SignInModal(props: Omit<ModalProps, "children"> & { startOnSignUp?: boolean }) {
  const { pathname, search } = useLocation();
  return (
    <Modal {...props}>
      <ModalContent>
        <SignIn
          className="shadow-none mx-auto px-0"
          redirectTo={`${pathname}${search}`}
          startOnSignUp={props.startOnSignUp}
        />
      </ModalContent>
    </Modal>
  );
}
